__turbopack_context__.v({
  "body": "SideBySide-module-scss-module__ink71q__body",
  "headline": "SideBySide-module-scss-module__ink71q__headline",
  "image": "SideBySide-module-scss-module__ink71q__image",
  "imageCol": "SideBySide-module-scss-module__ink71q__imageCol",
  "inner": "SideBySide-module-scss-module__ink71q__inner",
  "sideBySide": "SideBySide-module-scss-module__ink71q__sideBySide",
  "stack-module-0": "SideBySide-module-scss-module__ink71q__stack-module-0",
  "stack-module-1": "SideBySide-module-scss-module__ink71q__stack-module-1",
  "stack-module-10": "SideBySide-module-scss-module__ink71q__stack-module-10",
  "stack-module-11": "SideBySide-module-scss-module__ink71q__stack-module-11",
  "stack-module-12": "SideBySide-module-scss-module__ink71q__stack-module-12",
  "stack-module-13": "SideBySide-module-scss-module__ink71q__stack-module-13",
  "stack-module-14": "SideBySide-module-scss-module__ink71q__stack-module-14",
  "stack-module-15": "SideBySide-module-scss-module__ink71q__stack-module-15",
  "stack-module-16": "SideBySide-module-scss-module__ink71q__stack-module-16",
  "stack-module-17": "SideBySide-module-scss-module__ink71q__stack-module-17",
  "stack-module-18": "SideBySide-module-scss-module__ink71q__stack-module-18",
  "stack-module-19": "SideBySide-module-scss-module__ink71q__stack-module-19",
  "stack-module-2": "SideBySide-module-scss-module__ink71q__stack-module-2",
  "stack-module-20": "SideBySide-module-scss-module__ink71q__stack-module-20",
  "stack-module-3": "SideBySide-module-scss-module__ink71q__stack-module-3",
  "stack-module-4": "SideBySide-module-scss-module__ink71q__stack-module-4",
  "stack-module-5": "SideBySide-module-scss-module__ink71q__stack-module-5",
  "stack-module-6": "SideBySide-module-scss-module__ink71q__stack-module-6",
  "stack-module-7": "SideBySide-module-scss-module__ink71q__stack-module-7",
  "stack-module-8": "SideBySide-module-scss-module__ink71q__stack-module-8",
  "stack-module-9": "SideBySide-module-scss-module__ink71q__stack-module-9",
  "textCol": "SideBySide-module-scss-module__ink71q__textCol",
  "z-base": "SideBySide-module-scss-module__ink71q__z-base",
  "z-content": "SideBySide-module-scss-module__ink71q__z-content",
  "z-footer": "SideBySide-module-scss-module__ink71q__z-footer",
  "z-header": "SideBySide-module-scss-module__ink71q__z-header",
  "z-hero": "SideBySide-module-scss-module__ink71q__z-hero",
  "z-logo": "SideBySide-module-scss-module__ink71q__z-logo",
  "z-logo-effect": "SideBySide-module-scss-module__ink71q__z-logo-effect",
  "z-navigation": "SideBySide-module-scss-module__ink71q__z-navigation",
  "z-sub": "SideBySide-module-scss-module__ink71q__z-sub",
});
